module.exports = __webpack_public_path__ + "img/ethiopia.806c4d0f.png";